import React from 'react';
import SubnavMobileStyled from '../../../_atoms/SubnavMobileStyled';
import SubnavItem from '@molecules/SubnavItem';

const EditProfileMobileSubnav = () => (
    <SubnavMobileStyled>
        <SubnavItem label="Basic Information" to="/my-icsc/account/edit-profile/basic" />
        <SubnavItem label="Contact Information" to="/my-icsc/account/edit-profile/contact" />
        <SubnavItem label="Education & Employment" to="/my-icsc/account/edit-profile/education" />
        <SubnavItem label="Account Preferences" to="/my-icsc/account/edit-profile/prefs" />
    </SubnavMobileStyled>
);

export default EditProfileMobileSubnav;
